import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { MdmApiError } from "../Errors/MdmApiError";

export type ToastId = { current: ReturnType<typeof toast> | null };

export const showNotSelfClosingActionStartToast = (message: string) =>
  toast(message, {
    autoClose: false,
    closeButton: false,
  });

export const showActionSuccessToast = (toastId: ToastId, message: string) =>
  toast.update(toastId?.current || "", {
    type: "success",
    render: message,
    autoClose: 5000,
    closeButton: null, // The closeButton defined on ToastContainer will be used
  });

export const showNotSelfClosingActionSuccessToast = (toastId: ToastId, message: string) =>
  toast.update(toastId?.current || "", {
    type: "success",
    render: message,
    autoClose: false,
    closeButton: null, // The closeButton defined on ToastContainer will be used
  });

export const showActionFailureToast = (toastId: ToastId, message: string) =>
  toast.update(toastId?.current || "", {
    type: "error",
    render: message,
    autoClose: 5000,
    closeButton: null, // The closeButton defined on ToastContainer will be used
  });

export const showNotSelfClosingActionFailureToast = (toastId: ToastId, message: string) =>
  toast.update(toastId?.current || "", {
    type: "error",
    render: message,
    autoClose: false,
    closeButton: null, // The closeButton defined on ToastContainer will be used
  });

export const showNotSelfClosingApiErrorNotificationToast = (
  toastId: ToastId,
  error: AxiosError<MdmApiError>
): void => {
  const apiError = error.response?.data;
  return toast.update(toastId?.current || "", {
    type: "error",
    render:
      apiError?.title ?? apiError?.detail ?? `Unknown error with status code ${apiError?.status}`,
    autoClose: false,
    closeButton: null,
  });
};
